/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getMarkingTypesList } from '../fn/marking-type-controller/get-marking-types-list';
import { GetMarkingTypesList$Params } from '../fn/marking-type-controller/get-marking-types-list';
import { MarkingTypeWithRelations } from '../models/marking-type-with-relations';

@Injectable({ providedIn: 'root' })
export class MarkingTypeControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `markingTypeControllerGetMarkingTypesList()` */
  static readonly MarkingTypeControllerGetMarkingTypesListPath = '/marking-types';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMarkingTypesList()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMarkingTypesList$Response(params?: GetMarkingTypesList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MarkingTypeWithRelations>>> {
    return getMarkingTypesList(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMarkingTypesList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMarkingTypesList(params?: GetMarkingTypesList$Params, context?: HttpContext): Observable<Array<MarkingTypeWithRelations>> {
    return this.getMarkingTypesList$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<MarkingTypeWithRelations>>): Array<MarkingTypeWithRelations> => r.body)
    );
  }

}
